
const digest = '35777d17afeffcd985663110a7850df969fde029ce59d2ea836e9789a527d87b';
const classes = {"wrapper":"_wrapper_kcrab_1","bold":"_bold_kcrab_7"};
const css = `._wrapper_kcrab_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: column;
  gap: 10px;
}
._wrapper_kcrab_1 ._bold_kcrab_7 {
  font-weight: 600;
}
._wrapper_kcrab_1 a {
  color: #1665d8;
  font-weight: 600;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  